import { render, staticRenderFns } from "./Style3SkelCard.vue?vue&type=template&id=7a3b50a7&scoped=true"
var script = {}
import style0 from "./Style3SkelCard.vue?vue&type=style&index=0&id=7a3b50a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b50a7",
  null
  
)

export default component.exports